export function overWriteRoute(rootRouter, routerName, newRouter) {
    for (let i = 0; i < rootRouter.length; i++) {
        if (rootRouter[i].name === routerName) {
            rootRouter[i] = {...rootRouter[i], ...newRouter};
            return;
        }
        if (rootRouter[i].children) {
            overWriteRoute(rootRouter[i].children, routerName, newRouter);
        }
    }
}

export function findRoutes(rootRouter, routerNames) {
    let routes = [];
    for (let i = 0; i < routerNames.length; i++) {
        let routerName = routerNames[i];
        for (let j = 0; j < rootRouter.length; j++) {
            if (rootRouter[j].name === routerName) {
                routes.push(rootRouter[j]);
                break;
            }
            if (rootRouter[j].children) {
                routes = routes.concat(findRoutes(rootRouter[j].children, routerNames));
            }
        }
    }
    return routes;
}
